const localStorageKey = 'unseenOrders';

const initializeViewedOrdersArray = (orderIdArray) => {
  const arrayAsString = JSON.stringify(orderIdArray);
  localStorage.setItem(localStorageKey, arrayAsString);
};

const fetchViewedOrdersArray = () => {
  const array = localStorage.getItem(localStorageKey);
  return JSON.parse(array);
};

const setUpdatedViewedOrdersArray = (updatedArray) => {
  localStorage.setItem(localStorageKey, JSON.stringify(updatedArray));
};

const hasOrderBeenSeen = (orderId) => {
  const viewedOrdersArray = fetchViewedOrdersArray();
  if (viewedOrdersArray.includes(orderId)) {
    return false;
  }
  return true;
};

const markOrderAsSeen = (orderId) => {
  const viewedOrdersArray = fetchViewedOrdersArray();
  if (!viewedOrdersArray) {
    return;
  }
  const updatedOrdersArray = viewedOrdersArray.filter(
    (iteratedOrderId) => iteratedOrderId !== orderId
  );
  setUpdatedViewedOrdersArray(updatedOrdersArray);
};

const isActiveOrderBeingViewedForTheFirstTimePostSync = (orderId) => {
  const viewedOrdersArray = fetchViewedOrdersArray();
  if (!viewedOrdersArray) {
    return;
  }
  if (viewedOrdersArray.includes(orderId)) {
    return true;
  }
  return false;
};

export {
  initializeViewedOrdersArray,
  setUpdatedViewedOrdersArray,
  hasOrderBeenSeen,
  markOrderAsSeen,
  isActiveOrderBeingViewedForTheFirstTimePostSync,
};
